import React from 'react'
import styles from './gallery.module.scss'

type PaginationProps = {
  currentIndex: number
  total: number
}

export const Pagination: React.FC<PaginationProps> = ({
  currentIndex,
  total,
}) => (
  <div className={styles.gallery__pagination}>
    {currentIndex + 1} / {total}
  </div>
)
